import ChipColors from '@/app/arch/enums/ChipColors';

export default [
  {
    value: 'Processing',
    text: 'Processando',
    ...ChipColors.warning,
  },
  {
    value: 'Finished',
    text: 'Finalizado',
    ...ChipColors.success,
  },
  {
    value: 'Error',
    text: 'Erro',
    ...ChipColors.danger,
  },
];
